<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="listQuery.waybill_number" placeholder="请输入运单号" style="width: 200px;" clearable @clear="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="listQuery.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @clear="SearchData"
            @keyup.enter.native="SearchData"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="listQuery.result" placeholder="请选择结果" clearable @clear="SearchData" @keyup.enter.native="SearchData">
            <el-option label="一致" :value="1"></el-option>
            <el-option label="不一致" :value="2"></el-option>
            <el-option label="未验证" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>

        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <!-- 弹窗层编辑 -->
      <el-button class="action-item" icon="el-icon-arrow-left" @click="BatchReturn">返回</el-button>
      <el-button class="action-item" type="success" icon="el-icon-upload" @click="BatchCheck">核验</el-button>
      <!-- <el-button class="action-item" type="danger" icon="el-icon-delete" @click="BatchDelete">删除</el-button> -->
      <el-button class="action-item" type="warning" icon="el-icon-download" @click="ConfirmExportData('excel')">导出</el-button>
      <el-button class="action-item" type="warning" icon="el-icon-download" @click="ConfirmExportData('pdf')">PDF导出</el-button>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange" @selection-change="handleSelectionChange">
      <!--列开始-->
      <el-table-column align="center" type="selection"></el-table-column>
      <el-table-column align="center" type="index" width="50" label="序号 "></el-table-column>
      <el-table-column align="center" prop="bill_number" label="提单号 " show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="waybill_number" label="运单号 " show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="name" label="姓名 " show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="idcard" label="身份证号码 " width="180" show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="create_time" label="导入时间 " width="160"> </el-table-column>
      <el-table-column align="center" prop="status" label="状态 ">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status==2" type="success">已核验</el-tag>
          <el-tag v-if="scope.row.status==1" type="info">未核验</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="check_code" label="校验码 " width="270"> </el-table-column>
      <el-table-column align="center" prop="cost_num" label="计费次数 "> </el-table-column>
      <el-table-column align="center" prop="result" label="结果 ">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.result==1" type="success">一致</el-tag>
          <el-tag v-if="scope.row.result==2" type="info">不一致</el-tag>
          <el-tag v-if="scope.row.result==3" type="info">无记录</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button size="mini" type="success" plain icon="el-icon-upload" @click="HandleCheck(scopes.row)">核验</el-button>
          <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="HandleUpdate(scopes.row)">修改</el-button>
          <!-- <el-button style="color:#F56C6C;" icon="el-icon-delete" type="text" size="mini" @click="RowDelete(scopes.row)">删除</el-button> -->
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      :page-sizes="[10,20,50,100, 200, 500,1000]"
      :page-size="100"
      @pagination="loadData"
    />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible" width="600px">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="110px" style="width: 93%;">
        <el-form-item label="提单号 " prop="bill_number">
          <el-input v-model="temp.bill_number" disabled placeholder="请输入提单号" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="运单号 " prop="waybill_number">
          <el-input v-model="temp.waybill_number" disabled placeholder="请输入运单号" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="姓名 " prop="name">
          <el-input v-model="temp.name" placeholder="请输入姓名" maxlength="10" show-word-limit />
        </el-form-item>
        <el-form-item label="身份证号 " prop="idcard">
          <el-input v-model="temp.idcard" placeholder="请输入身份证号" />
        </el-form-item>
        <el-form-item label="状态 " prop="status">
          <el-radio-group v-model="temp.status" disabled>
            <el-radio :label="1">未核验</el-radio>
            <el-radio :label="2">已核验</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="录入时间 " prop="create_time">
          <el-date-picker
            v-model="temp.create_time"
            disabled
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
    <!-- 错误信息 -->
    <el-dialog
      title="核验提示"
      :visible.sync="dialogCheckErrorVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <div style="margin-bottom:20px;">有{{ check_error.length }}条数据核验失败：</div>
      <div style="height:240px;overflow-y: scroll;">
        <div v-for="(txt,index) in check_error" :key="index" style="margin:3px 0;">{{ txt }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogCheckErrorVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/user' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import dict_data from '@/api/system/dict_data'
export default {
  name: 'Detail',
  components: { Pagination },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      api,
      rules: {
        bill_number: [{ required: true, message: '请输入提单号', trigger: ['blur', 'change'] }],
        waybill_number: [{ required: true, message: '请输入运单号', trigger: ['blur', 'change'] }],
        name: [{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }],
        idcard: [{ required: true, validator: (rule, value, callback) => {
          const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
          if (!value) {
            callback(new Error('请输入身份证号'))
          } else if (!reg.test(value)) {
            callback(new Error('请输入正确的身份证号'))
          } else {
            callback()
          }
        }, trigger: ['blur', 'change'] }],
        create_time: [{ required: true, message: '请选择录入时间', trigger: ['blur', 'change'] }]
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'asc', // 默认排序方式,
        sort: 'order_no',
        group_id: this.$route.query.group_id
      },
      dialogCheckErrorVisible: false,
      check_error: [],
      lock: false,
      selects: [],
      selectIds: [],
      // 字典参数
      dictionary: []
      // 字典参数
    }
  },
  created() {
    this.loadData()
    dict_data.Drop({ sort: 'sort', order: 'asc', isPaginator: false, dict_code: '' }).then(response => {
      this.dictionary = response.data
    })
  },
  methods: {
    BatchReturn() {
      window.history.back()
    },
    BatchCheck() {
      if (!this.selectIds || this.selectIds.length === 0) {
        this.$notify({ message: '请先选择数据', type: 'warning', duration: 2000 })
        return
      }
      let a = false
      for (var i in this.selects) {
        if (this.selects[i].status === 2 && this.selects[i].result === 1) {
          a = true
          break
        }
      }
      if (a) {
        this.$confirm('用户数据存在已进行过的核验，如果再次核验，会导致重复计费，请慎重操作！', '提示', {
          confirmButtonText: '确定核验',
          cancelButtonText: '取消'
        }).then(() => {
          this.ConfimCheck(this.selectIds)
        })
      } else {
        this.$confirm('确定要核验吗?', '提示', {
          confirmButtonText: '确定核验',
          cancelButtonText: '取消'
        }).then(() => {
          this.ConfimCheck(this.selectIds)
        })
      }
    },
    HandleCheck(row) {
      if (row.status === 2 && row.result === 1) {
        this.$confirm('用户数据已经进行过核验，如果再次核验，会导致重复计费，请慎重操作！', '提示', {
          confirmButtonText: '确定核验',
          cancelButtonText: '取消'
        }).then(() => {
          this.ConfimCheck([row.id])
        })
      } else {
        this.$confirm('确定要核验吗?', '提示', {
          confirmButtonText: '确定核验',
          cancelButtonText: '取消'
        }).then(() => {
          this.ConfimCheck([row.id])
        })
      }
    },
    ConfimCheck(ids) {
      if (!ids || ids.length === 0) {
        return
      }
      if (this.lock === true) return
      this.lock = true
      api.Check({
        ids: ids
      }).then(response => {
        this.$store.dispatch('user/getInfo')
        this.loadData()

        const h = this.$createElement
        this.$msgbox({
          title: '核验完成',
          message: h('p', null, [
            h('span', null, '总数： ' + response.data.totalNum + '，'),
            h('span', { style: 'color: #409EFF' }, '已核验数： ' + response.data.checkNum + '，'),
            h('span', { style: 'color: #67C23A' }, '一致数： ' + response.data.yes + '，'),
            h('span', { style: 'color: #E6A23C' }, '不一致数： ' + response.data.no + '，'),
            // h('span', { style: 'color: #000000' }, '无记录数： ' + response.data.null + '，')
            h('span', { style: 'color: #F56C6C' }, '数据不规范： ' + response.data.error)
          ]),
          confirmButtonText: '关闭'
        })
        // this.dialogCheckErrorVisible = true
        setTimeout(() => {
          this.lock = false
        }, 2000)
      }).catch(() => {
        this.lock = false
      })
    },
    ConfirmExportData(type) {
      const params = []
      if (this.selectIds.length > 0) {
        params.push('ids=' + this.selectIds.join(','))
      } else {
        params.push('group_id=' + this.listQuery.group_id)
        if (this.listQuery.waybill_number) {
          params.push('waybill_number=' + this.listQuery.waybill_number)
        }
        if (this.listQuery.time) {
          params.push('time=' + this.listQuery.time)
        }
        if (this.listQuery.result) {
          params.push('result=' + this.listQuery.result)
        }
      }
      if (type === 'pdf') {
        window.open(process.env.VUE_APP_BASE_API + 'admin/user/exportPdf?' + params.join('&'))
      } else {
        location.href = process.env.VUE_APP_BASE_API + 'admin/user/exportExcel?' + params.join('&')
      }
    },
    handleSelectionChange(val) {
      this.selects = val
      this.selectIds = val.map(i => i.id)
    },
    resetTemp() {
      const date = new Date()
      date.valueFormat = 'yyyy-MM-dd HH:mm:ss'
      this.temp = {
        id: undefined,
        bill_number: '',
        waybill_number: '',
        name: '',
        idcard: '',
        status: 1,
        create_time: date
      }
    }

  }
}
</script>
<style>
.el-form-item__label{
  padding:0 20px 0 0
}
</style>
